import React from 'react'

const User = () => {
  return (
    <div>User</div>
  )
}

export default User